import { TransparencyGridIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel, useKestrelViewerContext } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { useState } from 'react'
import styled from 'styled-components'

const StyledTransparencyGridIcon = styled(TransparencyGridIcon)`
  path {
    opacity: 1;
  }
`

export const ChangeTextureButton: React.FC = () => {
  const { sendCommand } = useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrel()
  const [viewMode, setViewMode] = useState('Default')

  const color =
    viewMode === 'Default'
      ? 'rgb(200, 200, 200)'
      : viewMode === 'MatCap'
        ? 'rgb(140, 140, 140)'
        : viewMode === 'Wireframe'
          ? 'rgb(120, 120, 255)'
          : 'rgb(255, 0, 0)'

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Toggle texture'}>
      <ViewToggle
        onClick={() => {
          let nextViewMode = 'Default'
          if (viewMode === 'Default') nextViewMode = 'MatCap'
          else if (viewMode === 'MatCap') nextViewMode = 'Wireframe'
          else if (viewMode === 'Wireframe') nextViewMode = 'Nanite'
          else if (viewMode === 'Nanite') nextViewMode = 'Default'
          setViewMode(nextViewMode)
          sendCommand({
            command: KestrelCommands.SET_VIEW_MODE,
            viewModeId: nextViewMode,
          })
          trackButtonClicked({
            button_name: `kestrel_toggle_texture`,
            kestrel_model_id: kestrelModel?.data.kestrel_model_id,
            view_mode: nextViewMode,
          })
        }}>
        <StyledTransparencyGridIcon
          width={22}
          height={22}
          style={{ color: color }}
        />
      </ViewToggle>
    </TooltipWrapper>
  )
}
